<p class="text-title-lgx-bold">Tu clínica / consultorio</p>
<p class="text-info-bold-xs mt-xxs">¡VAMOS A DARLE IDENTIDAD A TU PROYECTO!</p>
<div class="tw-w-full tw-flex tw-flex-col tw-gap-4 md:tw-flex-row mt-xlg">
  <div class="tw-w-full md:tw-w-1/2">
    <p class="text-info mb-xs">LOGO</p>
    <div class="box-drop-logo cursor-pointer"
      [class.drag-enter]="dragEnter"
      nz-popover="" nzPopoverTitle="" [nzPopoverContent]="url ? 'Clic para cambiar el logo' : ''"
      (click)="input.click()" (drop)="onDropLogo($event)"
      (dragover)="allowDrop($event)" (dragenter)="onDragEnter()"
      (dragleave)="onDragLeave()">
      <p *ngIf="!url && !loaderImage" @fadeInAnimation class="text-regular-14 logo-drop-text">
        Arrastra tu logo o da clic aquí
      </p>
      <i *ngIf="loaderImage" class="icon-loader-image" nz-icon nzType="loading" nzTheme="outline"></i>
      <div *ngIf="url && !loaderImage" @fadeInAnimation class="container-image-selected">
        <img loading="lazy" [src]="this.url" alt="" style="max-height: 100%; max-width: 100%;">
      </div>
      <input
        #input
        type="file"
        accept="image/*"
        (change)="onSelectLogo($event.target['files'])"
        style="display: none"
        />
    </div>
  </div>
  <form #form="ngForm" class="tw-w-full md:tw-w-1/2">
    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col nzXs="24">
        <p class="text-info mb-xs">¿CÓMO SE LLAMA TU CLÍNICA/CONSULTORIO?</p>
        <input nz-input [(ngModel)]="clinicName" (focusout)="onFocusOut($event)"
          placeholder="Delie / Dr. Almazan"
          name="clinicName" #ngClinicName="ngModel" [required]="true">
        <app-message-field [field]="ngClinicName"></app-message-field>
      </div>
    </div>
  </form>
</div>
